import { REBRANDING_COM_TOGGLE } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'

export default () => {
  const rebrandingCOMTextExperiment = getExperimentOnClient(
    REBRANDING_COM_TOGGLE
  )

  if (rebrandingCOMTextExperiment.isEnabled) {
    void activateExperiment(REBRANDING_COM_TOGGLE)
  }
}
